import { memo } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";

import { reorderedRoutesListSelector } from "../../reducers/routeManagement/selectors";

import useWindowDimensions from "../../utils/useWindowDimensions";

import RouteList from "./RouteList";
import { View } from "../Base";
import { RouteSortBar } from "./RouteSortBar";
import { RouteExtractBar } from "./RouteExtractBar";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  list: {
    overflow: "auto",
    marginRight: "-14px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
});

export const DepotRouteDetail = memo(() => {
  const styles = useStyles();
  const routes = useSelector(reorderedRoutesListSelector);
  const { height: windowHeight } = useWindowDimensions();

  return (
    <div className={styles.container}>
      <RouteSortBar />
      <View className={styles.list}>
        <RouteList routes={routes} height={windowHeight - 238} />
      </View>
      <RouteExtractBar />
    </div>
  );
});

export default DepotRouteDetail;
